import { HttpHeaders } from '@angular/common/http';
import {HttpClientRequestOptions} from '@models/settings/http-client-request-options';

export const HTTPS_REQUEST_OPTIONS: HttpClientRequestOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
  withCredentials: true,
};

export const HTTPS_REQUEST_OPTIONS_FOR_FILES: HttpClientRequestOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
  withCredentials: true,
  responseType: 'blob' as 'json'
};
